"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectDrawingAngled = exports.selectRedos = exports.selectUndos = exports.selectSelectedItem = exports.selectSelectedTool = void 0;
const reselect_1 = require("reselect");
exports.selectSelectedTool = (0, reselect_1.createSelector)((state) => state.tools, (tools) => tools.selectedTool);
exports.selectSelectedItem = (0, reselect_1.createSelector)((state) => state.tools, (tools) => tools.selectedItem);
exports.selectUndos = (0, reselect_1.createSelector)((state) => state.tools, (tools) => tools.undos);
exports.selectRedos = (0, reselect_1.createSelector)((state) => state.tools, (tools) => tools.redos);
exports.selectDrawingAngled = (0, reselect_1.createSelector)((state) => state.tools, (tools) => tools.drawingAngled);
